import { normalizedEnv, pathUtils } from './env'

// Compose base API URLs
const ROOT = normalizedEnv.apiBaseUrl
const PREFIX = pathUtils.ensureLeadingSlash(normalizedEnv.apiPrefix)
const VERSION = pathUtils.ensureLeadingSlash(normalizedEnv.apiVersion)

export const BASE_API_URLS = {
  root: ROOT,
  versioned: `${ROOT}${PREFIX}${VERSION}`,
}

export type ApiBaseKind = 'root' | 'versioned'

export function buildApiUrl(path: string, kind: ApiBaseKind = 'versioned') {
  const base = kind === 'root' ? BASE_API_URLS.root : BASE_API_URLS.versioned
  const cleanPath = path.startsWith('/') ? path : `/${path}`
  return `${base}${cleanPath}`
}
